import CrehanaIso from "@crehana/icons/logos/CrehanaIso";
import cn from "clsx";
import Logo from "../Logo";
import { jsx as _jsx } from "react/jsx-runtime";
var BottomIconSidebar = function BottomIconSidebar(_ref) {
  var isDark = _ref.isDark,
    user = _ref.user,
    sidebarCollapsed = _ref.sidebarCollapsed,
    className = _ref.className;
  var currentIconColor = isDark ? '#9DA0BB' : '#BBBCBF';
  var currentLogo = sidebarCollapsed ? /*#__PURE__*/_jsx(CrehanaIso, {
    size: 12,
    color: currentIconColor
  }) : /*#__PURE__*/_jsx(Logo, {
    user: user
  });
  return /*#__PURE__*/_jsx("div", {
    className: cn("flex items-center py-8 px-16 border-solid border-t h-40 min-h-40", isDark ? 'border-base-lighter-16' : 'border-gray-lighter', user !== null && user !== void 0 && user.isB2B && !sidebarCollapsed ? 'tw-justify-start' : 'tw-justify-center', className),
    role: "presentation",
    "aria-label": "Powered by Crehana",
    children: currentLogo
  });
};
export default BottomIconSidebar;